import React from 'react';
// import LazyLoadTransition from '../../components/LazyLoadTransition/LazyLoadTransition';
import './Patronage.scss';

const Patronage = () => (
  <section className="section">
    {/* <LazyLoadTransition> */}
    <h1>PATRONAGE</h1>
    <div className="columns is-multiline is-centered patronage">
      <div className="column">
        <a href="https://www.prezident.sk/" rel="noreferrer" target="_blank">
          <div className="patronage-card-content">
            <img alt="Zuzana Čaputová " src="imgs/patronage/zuzanacaputova.jpeg" />
            <p className="column">
              <strong>Zuzana Čaputová</strong>
            </p>
            <p>
              President of the Slovak Republic Ms. Zuzana Čaputová took the patronage over the
              Openslava 2022 conference.
            </p>
          </div>
        </a>
      </div>
    </div>
    {/* </LazyLoadTransition> */}
  </section>
);

export default Patronage;
